import TransferOrderListController from './../controllers/transferorder.list.controller';

const TransferOrderListComponent = {
	templateUrl: 'components/transportauftrag/views/transferorder.list.html',
	controller: TransferOrderListController,
	bindings: {
		$router: '<'
	}
};

export default TransferOrderListComponent;
